import * as React from 'react';

const Checked = ({ width = '16px', height = '16px', fill = '#2BAB3F', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g mask="url(#a)">
      <path
        fill={fill}
        d="m7.054 9.43-1.55-1.548a.483.483 0 0 0-.347-.142.471.471 0 0 0-.355.142.478.478 0 0 0-.144.351c0 .138.048.255.144.352l1.83 1.83c.12.12.261.18.422.18.16 0 .3-.06.421-.18l3.71-3.71a.483.483 0 0 0 .141-.348.471.471 0 0 0-.142-.354.478.478 0 0 0-.35-.145.478.478 0 0 0-.352.145L7.054 9.43ZM8 14.334c-.876 0-1.7-.166-2.47-.498A6.397 6.397 0 0 1 3.52 12.48a6.394 6.394 0 0 1-1.355-2.01A6.163 6.163 0 0 1 1.667 8c0-.876.166-1.7.498-2.47A6.398 6.398 0 0 1 3.52 3.52a6.394 6.394 0 0 1 2.01-1.354 6.164 6.164 0 0 1 2.47-.5c.876 0 1.699.167 2.47.5.77.332 1.441.783 2.011 1.353.57.57 1.022 1.24 1.354 2.01.333.77.5 1.594.5 2.47 0 .876-.167 1.7-.5 2.47a6.399 6.399 0 0 1-1.353 2.011 6.396 6.396 0 0 1-2.01 1.354 6.163 6.163 0 0 1-2.47.5Z"
      />
    </g>
  </svg>
);

export default React.memo(Checked);
